import { render, staticRenderFns } from "./SelectBoxWithLabel.vue?vue&type=template&id=88c74936&scoped=true&"
import script from "./SelectBoxWithLabel.vue?vue&type=script&lang=js&"
export * from "./SelectBoxWithLabel.vue?vue&type=script&lang=js&"
import style0 from "./SelectBoxWithLabel.vue?vue&type=style&index=0&id=88c74936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c74936",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88c74936')) {
      api.createRecord('88c74936', component.options)
    } else {
      api.reload('88c74936', component.options)
    }
    module.hot.accept("./SelectBoxWithLabel.vue?vue&type=template&id=88c74936&scoped=true&", function () {
      api.rerender('88c74936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/common/common/Input/SelectBoxWithLabel.vue"
export default component.exports